import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function parseLocalDate(dateStr: string): Date {
  // Dates like "2026-02-25" (date-only) are interpreted as UTC by JS.
  // Adding T00:00:00 forces local timezone interpretation.
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return new Date(dateStr + "T00:00:00");
  }
  return new Date(dateStr);
}

/**
 * Formats a Date to "YYYY-MM-DD" using local timezone (not UTC).
 * Avoids the common bug where toISOString().split('T')[0] shifts the date
 * backward for timezones behind UTC.
 */
export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Formats a Date to "YYYY-MM-DD HH:mm" using local timezone.
 */
export function formatLocalDateTime(date: Date, time: string): string {
  return `${formatLocalDate(date)} ${time}`;
}

/**
 * Data da auditoria, na mesma hierarquia adotada em PR #155 (EditReport,
 * ReportCalendar, ReportDetail): data reagendada > data agendada > audit_date.
 * Cai em finalized_at apenas se nenhuma das três existir.
 */
export function getReportAuditDate(report: {
  teams_meeting_date?: string | null;
  original_teams_meeting_date?: string | null;
  audit_date?: string | null;
  finalized_at?: string | null;
}): Date | null {
  const dateSource =
    report.teams_meeting_date ||
    report.original_teams_meeting_date ||
    report.audit_date ||
    report.finalized_at;
  return dateSource ? parseLocalDate(dateSource) : null;
}
